import { useMutation } from '@tanstack/react-query';

import { useEnsureCsrfToken } from '~/context/CsrfContext';
import type { ToastData } from '~/hooks/useToast';
import type { CommunityScheduledPost } from '~/interfaces/community';

export type CreateCommunityScheduledPostResponse = { scheduled_post: CommunityScheduledPost } | { toast: ToastData };

const isCreateCommunityScheduledPostResponse = (data: unknown): data is CreateCommunityScheduledPostResponse =>
  typeof data === 'object' && data !== null && ('scheduled_post' in data || 'toast' in data);

const useCreateCommunityScheduledPostMutation = () => {
  const ensureCsrfToken = useEnsureCsrfToken();
  return useMutation({
    mutationFn: async (payload: Record<string, string>): Promise<CreateCommunityScheduledPostResponse> => {
      const csrfToken = await ensureCsrfToken();
      const response = await fetch('/community_scheduled_post', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'X-CSRF-Token': csrfToken,
        },
        body: new URLSearchParams(payload),
      });

      const data: unknown = await response.json();
      if (!isCreateCommunityScheduledPostResponse(data)) throw new Error('composer_invalid_response');

      return data;
    },
  });
};

export default useCreateCommunityScheduledPostMutation;
